<script lang="ts">
    import Fa from 'svelte-fa'
    import { FormTemplateItem } from '../../../modules/toolsApi/forms/form-templates/form-template-item'
    import { faClone, faCheckSquare, faCheckCircle, faCaretLeft, faCheck, faEdit, faSave, faTrash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { FormDataContent } from '../../../modules/toolsApi/forms/form-datas/form-data-content'
    let dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let item: FormTemplateItem
    export let multi: boolean
    export let editable: boolean
    export let value: FormDataContent = new FormDataContent()
    export let view = false

    let step = 1
    let locallabel = ''
    let localContent = ''
    let localContentScore = ''
    let localRequired = true
    let localAnother = false
    let localLocked = false
    let localScore = false

    function emitChange() {
        calculateScore()
        dispatch('change')
    }

    function calculateScore() {
        if (!item.contentScore) return
        let scoreMax
        if (multi) {
            scoreMax = item.contentScore.reduce((acc, cv) => (acc += parseInt(cv)), 0)
        } else {
            scoreMax = Math.max(...item.contentScore.map((el) => +el))
        }
        value.scoreMax = scoreMax
        if (!item.score) return
        let score = 0
        if (multi) {
            // `value.value` nem sempre é array: no editor de template o componente é montado sem
            // `value`, e o FormDataContent padrão deixa `value` undefined — o for...of lançava
            // "value is not iterable" ao abrir qualquer template com escolha múltipla pontuada.
            // Respostas antigas também podem vir como texto separado por vírgula (ver
            // checkShowAnother abaixo), e iterar a string contaria letra por letra.
            const selected = Array.isArray(value.value) ? value.value : typeof value.value === 'string' && value.value ? value.value.split(',') : []
            for (const v of selected) {
                const index = item.content.findIndex((el) => el === v)
                score += parseInt(item.contentScore[index])
            }
        } else {
            const index = item.content.findIndex((el) => el === value.value)
            score = parseInt(item.contentScore[index])
        }
        value.score = score
        console.log('score', score, scoreMax)
    }

    function goEdit() {
        locallabel = item.label || ''
        localContent = item.content.join(',')
        localContentScore = item.contentScore ? item.contentScore.join(',') : ''
        localRequired = item.required
        localAnother = item.another
        localLocked = item.locked
        localScore = item.score
        step = 2
        dispatch('edit', true)
    }

    function goRemove() {
        item = null
        dispatch('remove')
    }

    function goCancel() {
        dispatch('edit', false)
        step = 1
    }

    let isNew = false
    onMount(() => {
        isNew = editable && !item.label?.length
        if (isNew) {
            goEdit()
        }
        calculateScore()
    })

    function goSave() {
        if (locallabel.trim().length === 0) {
            window.error('Informe o texto a ser adicionado')
            return
        }
        if (localContent.trim().length === 0) {
            window.error('Informe as respostas')
            return
        }
        if (localScore) {
            const diff = localContent.split(',').length - localContentScore.split(',').length
            if (diff !== 0) {
                window.error('Cada alternativa deve possuir uma nota equivalente')
                return
            }
            for (const item of localContentScore.split(',').map((el) => el.trim())) {
                if (isNaN(parseInt(item))) {
                    window.error('As notas precisam ser numéricas')
                    return
                }
            }
        } else {
            localContentScore = ''
        }
        item.label = locallabel
        item.content = localContent.split(',').map((el) => el.trim())
        item.contentScore = localContentScore.split(',').map((el) => el.trim())
        item.required = localRequired
        item.another = localAnother
        item.locked = localLocked
        item.score = localScore
        dispatch('edit', false)
        dispatch('change')
        step = 1
    }

    $: showAnother = checkShowAnother(item, value)

    function checkShowAnother(item, value) {
        if (!item.another) return false
        if (!value.value) return false
        if (value.value.length === 0) return false
        let lastItem = item.content[item.content?.length - 1]
        if (Array.isArray(value.value)) {
            return value.value.includes(lastItem)
        } else {
            return value.value.split(',').includes(lastItem)
        }
    }

    function goClone() {
        dispatch('clone', item)
    }
</script>

<div class="cs_element cs_input_line cs_element-editable-{editable} {className}" class:draggable={step === 1}>
    {#if step === 1}
        {#if editable}
            <div class="acts acts_1 acts-absolute">
                <div class="spacer"></div>
                <button on:click={goClone} title="Clique para duplicar este elemento" class="btn btn-sm btn-secondary me-2"><Fa icon={faClone}></Fa></button>
                <button on:click={goEdit} class="btn btn-sm btn-warning"><Fa icon={faEdit}></Fa></button>
            </div>
        {/if}
    {:else}
        <div class="acts acts_2 acts-absolute">
            <div class="spacer"></div>
            <div class="btn-group">
                <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                {#if !isNew}
                    <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                {/if}
                <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
            </div>
        </div>
    {/if}

    {#if step === 1}
        <div class="cs_element_content">
            <div class="cs_item_title content_question">
                {@html item.label || ''}
            </div>
            <div class="content_answer">
                {#each item.content as option, index}
                    <div class="form-check form-check-inline">
                        {#if multi}
                            <input
                                class="form-check-input"
                                type="checkbox"
                                bind:group={value.value}
                                on:change={emitChange}
                                name="g_{item.id}"
                                id="g_{item.id}_{index}"
                                value={option}
                                disabled={view}
                            />
                        {:else}
                            <input
                                class="form-check-input"
                                type="radio"
                                bind:group={value.value}
                                on:change={emitChange}
                                name="g_{item.id}"
                                id="g_{item.id}_{index}"
                                value={option}
                                disabled={view}
                            />
                        {/if}
                        <label for="g_{item.id}_{index}" class="form-check-label"> {option}</label>
                    </div>
                {/each}
            </div>
            {#if showAnother}
                <div class="content_answer">
                    <div>Especifique</div>
                    <input disabled={view} type="text" bind:value={value.another} class="" />
                </div>
            {/if}
        </div>
    {:else}
        <div class="cs_element_edit">
            <div class="cs_element_edit_head">
                <div class="-title">
                    {#if multi}
                        <Fa icon={faCheckSquare}></Fa>
                        <div>Campo de escolha múltipla</div>
                    {:else}
                        <Fa icon={faCheckCircle}></Fa>
                        Campo de escolha única
                    {/if}
                </div>
                <div class="spacer"></div>
                <div class="btn-group">
                    <button on:click={goRemove} class="btn btn-sm btn-warning"><Fa icon={faTrash}></Fa>&nbsp;Excluir</button>
                    {#if !isNew}
                        <button on:click={goCancel} class="btn btn-sm btn-secondary"><Fa icon={faCaretLeft}></Fa>&nbsp;Cancelar</button>
                    {/if}
                    <button on:click={goSave} class="btn btn-sm btn-primary"><Fa icon={faCheck}></Fa>&nbsp;Confirmar</button>
                </div>
            </div>
            <div class="cs_element_edit_body">
                <label for="" class="-title">Configurações</label>
                <div class="input-inline">
                    <div class="form-check form-switch me-3">
                        <input class="form-check-input" bind:checked={localRequired} type="checkbox" role="switch" id="localRequired" />
                        <label class="form-check-label" for="localRequired">obrigatório</label>
                    </div>
                    <div class="form-check form-switch me-3">
                        <input class="form-check-input" bind:checked={localLocked} type="checkbox" role="switch" id="localLocked" />
                        <label class="form-check-label" for="localLocked">Apenas leitura</label>
                    </div>
                    <div class="form-check form-switch me-3">
                        <input class="form-check-input" bind:checked={localAnother} type="checkbox" role="switch" id="localAnother" />
                        <label class="form-check-label" for="localAnother">Exibir 'Especifique'</label>
                    </div>
                    <div class="form-check form-switch me-3">
                        <input class="form-check-input" bind:checked={localScore} type="checkbox" role="switch" id="localScore" />
                        <label class="form-check-label" for="localScore" title="Atribua pontos a determinada opção respondida">Com pontuação</label>
                    </div>
                </div>
                <label for="" class="-title">Questão</label>
                <input type="text" bind:value={locallabel} class="" />
                <label for="" class="-title">Respostas</label>
                <input type="text" bind:value={localContent} class="" />
                {#if localScore}
                    <label for="" class="-title">Pontos de acordo com a resposta</label>
                    <input type="text" bind:value={localContentScore} class="" />
                {/if}
            </div>
        </div>
    {/if}
</div>
